/* eslint-disable react-hooks/exhaustive-deps */

import { useState } from "react";

import { useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";

import axios from "axios";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";

import { Tooltip } from "@mui/material";



import MDBox from "components/MDBox";

import MDTypography from "components/MDTypography";

import MDButton from "components/MDButton";

import { Avatar, Segmented, Tag } from "antd";

import { useSnackbar } from "notistack";

import { DatePicker } from "antd";

import dayjs from "dayjs";

import { ReactComponent as Usergroupicon } from "../../assets/images/icons/usergroup.svg";

import { ReactComponent as NotificationIcon } from "../../assets/images/icons/usernotification.svg";

import { format } from "date-fns";

import DeleteIcon from "@mui/icons-material/Delete";

import VisibilityIcon from "@mui/icons-material/Visibility";

import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import CustomMaterialTable from "../../components/custom/CustomMaterialTable";

import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

import OutlinedInput from "@mui/material/OutlinedInput";

import {

  TextField,

  Typography,

  CardContent,

  Switch,

  FormControlLabel,

} from "@mui/material";

import { AccessTime, CalendarToday } from "@mui/icons-material";

import TableRefreshButton from "components/Loadable/TableRefreshButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import utc from "dayjs/plugin/utc";

import { useMaterialUIController } from "context";

import Loader from "components/custom/Loader";

import timezone from "dayjs/plugin/timezone";

import "./notification.css";

import Emailnoti from "./Emailnoti";

import { GlobalStyles } from "@mui/material";

import useApiRequest from "utils/Apirequest";

import { useLocation } from "react-router-dom";

import useNotificationWorker from "hooks/useNotificationWorker";

import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";

import { convertUTCtoDubai } from "utils/Constant";

import {

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

} from "@mui/material";



import { handleSignout } from "utils/Logout";

import { getDecodedUserData } from "utils/Constant";

import { isValidPhone } from "utils/Constant";



dayjs.extend(utc);

dayjs.extend(timezone);



function Notifications() {

  const location = useLocation();

  const [content] = useState(location?.state);

  const [controller] = useMaterialUIController();

  const { darkMode } = controller;

  const { sidenavColor } = controller;

  const [isScheduleTableLoading, setIsScheduleTableLoading] = useState(true);

  const [isHistoryTableLoading, setIsHistoryTableLoading] = useState(true);

  const [columns, setColumns] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const [selectedVal, setSelectedVal] = useState("allUser");

  // eslint-disable-next-line no-unused-vars 

  const [mode, setMode] = useState("notification");

  const [title, setTitle] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");

  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [description, setDescription] = useState("");

  const [selectedDate, setSelectedDate] = useState(dayjs());

  const dateFormat = "YYYY-MM-DD HH:mm";

  const [preview, setPreview] = useState(false);

  const [visibile, setVisibile] = useState(true);

  const [schedule, setSchedule] = useState(false);

  const [rows, setRows] = useState([]);

  const [rows1, setRows1] = useState([]);

  const [isDescModalOpen, setIsDescModalOpen] = useState(false);

  const [descModalTitle, setDescModalTitle] = useState("");

  const [descModalText, setDescModalText] = useState("");

  const [errors, setErrors] = useState({});



  const apiRequest = useApiRequest();



  const [pagination, setPagination] = useState({

    pageIndex: 0,

    pageSize: 20,

  });

  const [columnFilters, setColumnFilters] = useState([]);

  const [page, setPage] = useState(0);

  const [searchText, setSearchText] = useState("");

  const [isUserSearching, setIsUserSearching] = useState(false);

  const searchTimeoutRef = useRef(null);

  const [sorting, setSorting] = useState([

    {

      id: "createdAt",

      desc: true,

    },

  ]);

  const [pageSize, setPageSize] = useState(20);

  const [totalRows, setTotalRows] = useState(0);

  const [columnVisibility, setColumnVisibility] = useState({});

  const [scheduleColumnVisibility, setScheduleColumnVisibility] = useState({

    status: true,

    title: true,

    description: true,

    type: true,

    "userId.username": true,

    "userId._id": true,

    scheduleTime: true,

    updatedAt: true,

    createdAt: true,

    action: true,

  });



  const navigate = useNavigate();


  const fetchHistory = async () => {
    try {
      setIsHistoryTableLoading(true);

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BASEURL}notification/sent-or-failed`,
        params: {
          page: page + 1,
          limit: pageSize,
          sortField: sorting[0]?.id || "",
          sortOrder: sorting[0]?.desc ? "desc" : "asc",
          search: searchText,
        },
        withCredentials: true,
      });

      if (response.data.success === true) {
        const sortedRows = response.data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setRows1(sortedRows);
        setTotalRows(response.data.total);
      } else {
        enqueueSnackbar(response.data.message, { variant: "error" });
      }
    } catch (error) {
      console.error(error);

      if (error?.response?.status === 401) {
        handleSignout();
      }

      enqueueSnackbar(
        error.response?.data?.message || "Failed to fetch history",
        { variant: "error" }
      );
    } finally {
      setIsHistoryTableLoading(false);
    }
  };
  // Handle data fetched from Web Worker 

  // const handleDataFetched = (data) => {

  //   // Only update if user is not actively searching 

  //   if (!isUserSearching) {

  //     if (data?.success === true) {

  //       const sortedRows = data?.data?.sort(

  //         (a, b) => new Date(b.createdAt) - new Date(a.createdAt)

  //       );

  //       setRows1(sortedRows);

  //       setIsHistoryTableLoading(false);

  //       setTotalRows(data?.total);

  //     } else {

  //       setIsHistoryTableLoading(false);

  //     }

  //   }

  // };



  // // Handle worker errors 

  // const handleWorkerError = (error) => {

  //   console.error('Worker error:', error);

  //   setIsHistoryTableLoading(false);

  // };



  // // Initialize Web Worker for background polling 

  // const { startPolling, stopPolling, fetchNow, isPolling } = useNotificationWorker({

  //   baseUrl: process.env.REACT_APP_BASEURL,

  //   page: page + 1,

  //   limit: pageSize,

  //   sortField: sorting[0]?.id || '',

  //   sortOrder: sorting[0]?.desc ? 'desc' : 'asc',

  //   search: searchText,

  //   pollInterval: 10000, // 10 seconds 

  //   onDataFetched: handleDataFetched,

  //   onError: handleWorkerError,

  //   enabled: true,

  // });



  // // Start polling when component mounts 

  // useEffect(() => {

  //   startPolling();

  //   return () => {

  //     stopPolling();

  //   };

  // }, [startPolling, stopPolling]);



  // Handle search text changes with debounce 

  // useEffect(() => {

  //   // Clear existing timeout 

  //   if (searchTimeoutRef.current) {

  //     clearTimeout(searchTimeoutRef.current);

  //   }



  //   // Set user as searching 

  //   setIsUserSearching(true);



  //   // Debounce search - wait 500ms after user stops typing 

  //   searchTimeoutRef.current = setTimeout(() => {

  //     setIsUserSearching(false);

  //     // Trigger immediate fetch with new search term 

  //     fetchNow();

  //   }, 500);



  //   return () => {

  //     if (searchTimeoutRef.current) {

  //       clearTimeout(searchTimeoutRef.current);

  //     }

  //   };

  // }, [searchText, fetchNow]);



  // When page, pageSize, or sorting changes, fetch immediately 

  useEffect(() => {
    fetchHistory();
  }, [page, pageSize, sorting, searchText]);


  const handleReloadHistory = () => {
    fetchHistory();
  };



  const templates = [

    { id: 0, label: "Custom", title: "", description: "" },

    {

      id: "1",

      label: "Low Battery Alert",

      title: "Low Battery – Please Recharge",

      description:

        "Your vehicle's battery percentage is low. Please head to the nearest charging station to avoid service interruption.",

    },

    {

      id: "2",

      label: "Maintenance Reminder",

      title: "Vehicle Maintenance Due",

      description:

        "It’s time for your scheduled EV maintenance check. Please visit your service center at your earliest convenience.",

    },

  ];



  useEffect(() => {

    if (content) {

      setSelectedTemplate(1);

      setTitle("Low Battery – Please Recharge");

      setDescription(

        "Your vehicle's battery percentage is low. Please head to the nearest charging station to avoid service interruption."

      );

      setSelectedVal("singleUser");

      const cleaned = content.replace(/^0+/, "");

      setPhoneNumber(cleaned);

    }

  }, [content]);



  useEffect(() => {

    setPage(pagination.pageIndex);

    setPageSize(pagination.pageSize);

  }, [pagination]);



  const handleTemplateChange = (event) => {

    const selected = templates.find((t) => t.id === event.target.value);

    setSelectedTemplate(event.target.value);

    setTitle(selected.title);

    setDescription(selected.description);

  };



  const handleOpenDescriptionModal = (title, description) => {

    setDescModalTitle(title || "Description");

    setDescModalText(description || "");

    setIsDescModalOpen(true);

  };



  const handleSortingChange = (newSorting) => {

    setSorting(newSorting);

  };



  const handleSearchChange = (event) => {

    setSearchText(event);

    setPage(0);

  };



  useEffect(() => {

    setColumns(column);

  }, []);

  const statusList = ["Failed", "Sent"];

  const statusList1 = ["Failed", "Scheduled"];

  const handleDelete = (row_data) => {

    axios({

      method: "delete",

      url: process.env.REACT_APP_BASEURL + "notification/" + row_data._id,

      headers: {

        "Content-Type": "application/json",

      }, withCredentials: true,



    })

      .then((response) => {

        if (response.data.status === true) {

          enqueueSnackbar(response?.data?.message, { variant: "success" });

          window.location.reload();

        } else {

          enqueueSnackbar(response.data.message, { variant: "error" });

        }

      })

      .catch((error) => {

        console.log(error);

        enqueueSnackbar(error.response?.data?.message, { variant: "error" });

        if (error?.response?.status === 401) {

          handleSignout();

        }

      });

  };



  const convertSchedule = (cron) => {

    if (!cron || typeof cron !== "string") return "N/A";



    const parts = cron.split(" ");



    // Expecting: minute hour day month * 

    if (parts.length !== 5) return "N/A";



    const [minute, hour, day, month] = parts.map(Number);



    // Validate numbers 

    if (

      [minute, hour, day, month].some(

        (val) => Number.isNaN(val)

      )

    ) {

      return "N/A";

    }



    const year = new Date().getFullYear();



    const date = new Date(

      Date.UTC(year, month - 1, day, hour, minute)

    );



    if (isNaN(date.getTime())) return "N/A";



    return format(date, "dd MMM yyyy, HH:mm");

  };



  const handleView = (row_data) => {

    window.scrollTo({ top: 0, behavior: "smooth" });

    if (visibile) {

      setPreview(true);

      setTitle(row_data.title);

      setPhoneNumber(row_data.phoneNumber);

      setDescription(row_data.description);

    } else {

      setTitle("");

      setPhoneNumber("");

      setDescription("");

    }

    setVisibile(!visibile);

  };

  const column = [

    {

      header: "Status",

      accessorKey: "status",

      align: "center",

      fixed: "true",

      filterVariant: "select",

      filterSelectOptions: statusList,

      size: 190,

      muiTableHeadCellProps: { align: "center" },

      muiTableBodyCellProps: { align: "center" },



      Cell: ({ row }) => {

        const status = row.original.status;



        const statusColors = {

          Failed: "red",

          Pending: "default",

          Scheduled: "yellow",

          Sent: "green",

        };



        const color = statusColors[status] || "yellow";



        return (

          <MDBox

            display="flex"

            justifyContent="center"

            alignItems="center"

            borderRadius="md"

            style={{ flex: 1 }}

          >

            <Tag color={color}>{status}</Tag>

          </MDBox>

        );

      },

    },

    {

      header: "Title",

      accessorKey: "title",

      align: "center",

      size: 170,

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",



      },

      Cell: ({ cell }) => {

        const value = cell.getValue() || "N/A";

        const isLong = value.length > 25; // adjust if needed 



        return (

          <Tooltip

            title={isLong ? value : ""}

            arrow

            slotProps={{

              tooltip: {

                sx: {

                  backgroundColor: "rgba(50,50,50,0.85)",

                  color: "#fff",

                },

              },

              arrow: {

                sx: {

                  color: "rgba(50,50,50,0.85)",

                },

              },

            }}

          >

            <span

              style={{

                display: "inline-block",

                maxWidth: 160,

                overflow: "hidden",

                textOverflow: "ellipsis",

                whiteSpace: "nowrap",

                verticalAlign: "bottom",

              }}

            >

              {value}

            </span>

          </Tooltip>

        );

      },

    },

    {

      header: "Description",

      accessorKey: "description",

      align: "center",

      size: 230,



      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

        style: { width: 120, maxWidth: 120, fontSize: 14, lineHeight: "20px" },

      },

      Cell: ({ cell, row }) => {

        const value = cell.getValue() || "N/A";

        const ref = useRef(null);

        const [isTruncated, setIsTruncated] = useState(false);



        useEffect(() => {

          if (ref.current) {

            setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth);

          }

        }, [value]);



        const handleReadMore = () => {

          handleOpenDescriptionModal(row.original.title, value);

        };



        return (

          <div

            style={{

              display: "flex",

              alignItems: "center",

              width: "100%",

              gap: 6,

              justifyContent: "center",

            }}

          >

            <div

              ref={ref}

              style={{

                flex: 1,

                minWidth: 0,

                whiteSpace: "nowrap",

                overflow: "hidden",

                textOverflow: "ellipsis",

                textAlign: "center",

                fontSize: 14,

                lineHeight: "20px",

              }}

            >

              {value}

            </div>



            {isTruncated && value !== "N/A" && (

              <span

                role="button"

                tabIndex={0}

                onClick={handleReadMore}

                onKeyDown={(e) => e.key === "Enter" && handleReadMore()}

                style={{

                  marginLeft: 6,

                  color: "#1976d2",

                  fontSize: 12,

                  lineHeight: 1,

                  cursor: "pointer",

                  whiteSpace: "nowrap",

                  textDecoration: "underline",

                }}

              >

                Read more

              </span>

            )}

          </div>

        );

      },

    },

    {

      header: "Sent to",

      size: 200,

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "type",

      align: "center",

    },

    {

      header: "Created By",

      size: 230,

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "userId.username",

      align: "center",

    },

    {

      header: "Sent Date & Time",

      size: 200,

      accessorKey: "updatedAt",

      align: "center",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      size: 300,

      Cell: ({ cell }) => {

        return convertUTCtoDubai(cell.getValue());

      },

    },

    {

      header: "Created Date & Time",

      accessorKey: "createdAt",

      align: "center",

      muiTableHeadCellProps: {

        align: "center",

      },

      size: 300,

      muiTableBodyCellProps: {

        align: "center",

      },

      Cell: ({ cell }) => {

        return convertUTCtoDubai(cell.getValue());

      },

    },

  ];

  const column1 = [

    {

      header: "Status",

      accessorKey: "status",

      align: "center",

      fixed: "true",

      filterVariant: "select",

      filterSelectOptions: statusList1,



      muiTableHeadCellProps: { align: "center" },

      muiTableBodyCellProps: { align: "center" },



      Cell: ({ row }) => {

        const status = row.original.status;

        const statusColors = {

          Failed: "red",

          Pending: "default",

          Scheduled: "yellow",

          Sent: "green",

        };



        const color = statusColors[status] || "yellow";



        return (

          <MDBox

            display="flex"

            justifyContent="center"

            alignItems="center"

            borderRadius="md"

            style={{ flex: 1 }}

          >

            <Tag color={color}>{status}</Tag>

          </MDBox>

        );

      },

    },

    {

      header: "Title",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "title",

      align: "center",

    },

    {

      header: "Description",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      size: 350,

      accessorKey: "description",

      align: "center",

    },

    {

      header: "Schedule Time",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },
      size: 250,

      accessorKey: "scheduleTime",

      align: "center",

      Cell: ({ cell }) => {

        return convertSchedule(cell.getValue());

      },

    },

    {

      header: "Notification Type",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "type",

      align: "center",

    },

    {

      header: "Created By",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "userId.username",

      align: "center",

    },

    {

      header: "Created At",

      accessorKey: "createdAt",

      align: "center",

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      Cell: ({ cell }) => {

        return convertUTCtoDubai(cell.getValue());

      },

    },

    {

      header: "Updated At",

      accessorKey: "updatedAt",

      align: "center",

      muiTableHeadCellProps: { align: "center" },

      muiTableBodyCellProps: { align: "center" },

      Cell: ({ cell }) =>

        cell.getValue() ? convertUTCtoDubai(cell.getValue()) : "N/A",

    },



    {

      header: "Action",

      enableColumnFilter: false,

      muiTableHeadCellProps: {

        align: "center",

      },

      muiTableBodyCellProps: {

        align: "center",

      },

      accessorKey: "action",

      align: "center",

      Cell: (row) =>

        row.row.depth === 0 ? (

          <div

            style={{

              position: "sticky",

              right: "0",

              zIndex: "111",

            }}

          >

            <Tooltip title={visibile ? "Show Preview" : "Hide Preview"} arrow>

              <MDButton

                onClick={(e) => handleView(row.row.original)}

                variant="gradient"

                color={visibile ? "info" : "success"}

                iconOnly

              >

                {visibile ? <VisibilityIcon /> : <VisibilityOffIcon />}

              </MDButton>

            </Tooltip>

            <Tooltip title="Delete" arrow>

              <MDButton

                sx={{

                  marginLeft: 2,

                }}

                onClick={(e) => handleDelete(row.row.original)}

                variant="gradient"

                color="error"

                iconOnly

              >

                <DeleteIcon />

              </MDButton>

            </Tooltip>

          </div>

        ) : null,

    },

  ];



  const limitText = (text, wordLimit = 15, charLimit = 80) => {

    if (!text) return "No title";



    const words = text.trim().split(/\s+/);



    // If text has multiple words → limit by words 

    if (words.length > 1) {

      return words.length > wordLimit

        ? words.slice(0, wordLimit).join(" ") + "..."

        : text;

    }



    // If single long word → limit by characters 

    return text.length > charLimit

      ? text.slice(0, charLimit) + "..."

      : text;

  };



  useEffect(() => {

    if (getDecodedUserData()?.login_status !== "true") {

      navigate("/sign-in");

    }

    axios({

      method: "get",

      url: process.env.REACT_APP_BASEURL + "notification/scheduled",

      withCredentials: true,



    })

      .then((response) => {

        if (response.data.status === true) {

          setRows(response.data.data);

          setIsScheduleTableLoading(false);

        } else {

          enqueueSnackbar(response.data.message, { variant: "error" });

          setIsScheduleTableLoading(false);

        }

      })

      .catch((error) => {

        console.log(error);

        if (error?.response?.status === 401) {

          handleSignout();

        }

      });

  }, []);



  const createUser = (title, description, phoneNumber) => {

    let payload;

    if (schedule) {

      const scheduleDate = dayjs(selectedDate).utc().format("m H D M *");

      payload = {

        title: title,

        message: description,

        phoneNumber: phoneNumber,

        scheduleTime: scheduleDate,

      };

    } else {

      payload = {

        title: title,

        message: description,

        phoneNumber: phoneNumber,

      };

    }



    axios({

      method: "post",

      url: `${process.env.REACT_APP_BASEURL}notification/${schedule ? "schedule-notification-to-all" : selectedVal === "singleUser" ? "send-notification" : "send-notification-to-all"}`,

      data: payload,

      headers: {

        "Content-Type": "application/json",

      }, withCredentials: true,



    })

      .then((response) => {

        if (response.data.status === true) {

          setTitle("");

          setDescription("");

          setPhoneNumber("");

          enqueueSnackbar(response?.data?.message, { variant: "success" });

        } else {

          enqueueSnackbar(response?.data?.message, { variant: "error" });

        }

      })

      .catch((error) => {

        console.log(error);

        enqueueSnackbar(error, { variant: "error" });

        if (error?.response?.status === 401) {

          handleSignout();

        }

      });

  };

  const handleSubmit = (event) => {

    event.preventDefault();

    if (title === "" || description === "") {

      return enqueueSnackbar("All fields are necessary", { variant: "error" });

    }

    if (selectedVal === "singleUser" && phoneNumber === "") {

      return enqueueSnackbar("All fields are necessary", { variant: "error" });

    }

    createUser(title, description, phoneNumber);

  };



  const disabledDate = (current) => {

    return current && current < dayjs().tz("Asia/Dubai").startOf("day");

  };



  const disabledTime = (current) => {

    const nowDubai = dayjs().tz("Asia/Dubai");



    // If selected date is NOT today → allow all times 

    if (!current || !current.isSame(nowDubai, "day")) {

      return {};

    }



    const currentHour = nowDubai.hour();

    const currentMinute = nowDubai.minute();



    return {

      disabledHours: () =>

        Array.from({ length: currentHour }, (_, i) => i),



      disabledMinutes: (selectedHour) =>

        selectedHour === currentHour

          ? Array.from({ length: currentMinute }, (_, i) => i)

          : [],

    };

  };



  return (

    <>

      <DashboardLayout>

        <DashboardNavbar />

        {/* <ToggleButtonGroup 

          className="toolBox" 

          value={mode} 

          exclusive 

          onChange={(e, value) => { 

            if (value !== null) setMode(value); 

          }} 

          style={{ 

            marginBottom: "1.5rem", 

            backgroundColor: darkMode ? "#202940" : "#00000000", 

            color: darkMode ? "#fff" : "#000", 

          }} 

        > 

          <ToggleButton 

            value="notification" 

            style={{ 

              border: "none", 

              borderBottom: 

                mode === "notification" 

                  ? `2px solid ${colorMap[sidenavColor]}` 

                  : "none", 

 

              borderRadius: "8px", 

              fontSize: "14px", 

              backgroundColor: darkMode 

                ? mode === "notification" 

                  ? "rgb(52, 71, 103)" 

                  : "#202940" 

                : mode === "notification" 

                  ? "white" 

                  : "transparent", 

              color: darkMode ? "#fff" : "#000", 

            }} 

          > 

            Send Notification 

          </ToggleButton> */}



        {/* <ToggleButton 

            className="toolBox" 

            value="email" 

            style={{ 

              borderBottom: 

                mode === "email" 

                  ? `2px solid ${colorMap[sidenavColor]}` 

                  : "none", 

              borderRadius: "8px", 

              border: "none", 

              fontSize: "14px", 

              backgroundColor: darkMode 

                ? mode === "email" 

                  ? "rgb(52, 71, 103)" 

                  : "#202940" 

                : mode === "email" 

                  ? "white" 

                  : "transparent", 

              color: darkMode ? "#fff" : "#000", 

            }} 

          > 

            Send Email 

          </ToggleButton> */}

        {/* </ToggleButtonGroup> */}



        {mode === "notification" ? (

          <MDBox mt={2} mb={2}>

            <Grid container spacing={2}>

              {/* Left Panel - Form */}

              <Grid item xs={12} md={8}>

                <Card

                  variant="outlined"

                  style={{

                    padding: "8px",

                  }}

                >

                  <CardContent>

                    <MDTypography variant="h6" mb={2}>

                      Send Notification

                    </MDTypography>

                    <FormControl fullWidth margin="normal">

                      <InputLabel id="template-label">

                        Select Notification Template

                      </InputLabel>



                      <Select

                        labelId="template-label"

                        value={selectedTemplate}

                        onChange={handleTemplateChange}

                        IconComponent={ArrowDropDownIcon}

                        label="Select Notification Template"

                        sx={{

                          height: 50,

                          marginBottom: "1.2rem",



                          // FORCE dropdown arrow 

                          "& .MuiSelect-icon": {

                            display: "block !important",

                            visibility: "visible !important",

                            opacity: 1,

                            color: "#6b6b6b",

                            right: 12,

                          },



                          //  space so text doesn't overlap arrow 

                          "& .MuiOutlinedInput-input": {

                            paddingRight: "40px",

                          },

                        }}

                      >

                        {templates.map((template) => (

                          <MenuItem key={template.id} value={template.id}>

                            {template.label}

                          </MenuItem>

                        ))}

                      </Select>

                    </FormControl>



                    <Dialog

                      open={isDescModalOpen}

                      onClose={() => setIsDescModalOpen(false)}

                      maxWidth="sm"

                      fullWidth

                    >

                      <DialogTitle>

                        {descModalTitle || "Description"}

                      </DialogTitle>

                      <DialogContent dividers>

                        <Typography

                          variant="body2"

                          sx={{ whiteSpace: "pre-wrap" }}

                        >

                          {descModalText || "No description"}

                        </Typography>

                      </DialogContent>

                      <DialogActions>

                        <MDButton

                          variant="gradient"

                          color={sidenavColor}

                          onClick={() => setIsDescModalOpen(false)}

                        >

                          Close

                        </MDButton>

                      </DialogActions>

                    </Dialog>



                    <div className="mobileNumber">

                      <Segmented

                        options={[

                          {

                            label: (

                              <div

                                style={{

                                  padding: 4,

                                }}

                              >

                                <Avatar

                                  style={{

                                    backgroundColor: "transparent",

                                    width: "4.5rem",

                                  }}

                                  icon={

                                    <Usergroupicon

                                      style={{}}

                                      className={

                                        darkMode ? "usergroup-icon" : ""

                                      }

                                    />

                                  }

                                />

                                <div> All user</div>

                              </div>

                            ),

                            value: "allUser",

                          },

                          {

                            label: (

                              <div

                                style={{

                                  padding: 4,

                                }}

                              >

                                <Avatar

                                  style={{

                                    backgroundColor: "transparent",

                                  }}

                                  icon={

                                    <NotificationIcon

                                      className={

                                        darkMode ? "usergroup-icon" : ""

                                      }

                                    />

                                  }

                                />

                                <div>Single User</div>

                              </div>

                            ),

                            value: "singleUser",

                          },

                        ]}

                        onChange={(value) => {

                          setSelectedVal(value);

                        }}

                        style={{

                          marginBottom: "1.2rem",

                          backgroundColor: darkMode ? "#202940" : "#f5f5f5",

                          color: darkMode ? "#fff" : "#000",

                        }}

                      />

                      {selectedVal === "singleUser" ? (

                        <TextField

                          type="text"

                          label="Driver ID"

                          placeholder="Enter Driver ID"

                          value={phoneNumber}

                          margin="normal"

                          onChange={(e) => setPhoneNumber(e.target.value)}

                          onBlur={(e) => {
                            const value = e.target.value;

                            const isNumeric = /^[0-9]+$/.test(value);

                            setErrors((prev) => ({
                              ...prev,
                              phone_number: value === ""
                                ? ""
                                : isNumeric
                                  ? ""
                                  : "Phone number must contain only digits",
                            }));
                          }}


                          error={Boolean(errors.phone_number)}

                          helperText={errors.phone_number}

                          sx={{

                            "& .MuiFormHelperText-root": {

                              color: "error.main",

                            },

                            "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":

                            {

                              borderColor: "error.main",

                            },

                          }}

                        />

                      ) : null}

                    </div>

                    <TextField

                      fullWidth

                      label="Title"

                      value={title}

                      onChange={(e) => setTitle(e.target.value)}

                      margin="normal"

                    />

                    <TextField

                      fullWidth

                      label="Description"

                      value={description}

                      onChange={(e) => setDescription(e.target.value)}

                      margin="normal"

                      multiline

                      rows={3}

                    />



                    <Grid container spacing={2} sx={{ mt: 2 }}>

                      <Grid item>

                        <MDButton

                          variant={schedule ? "outlined" : "contained"}

                          color="error"

                          startIcon={<AccessTime />}

                          onClick={() => setSchedule(false)}

                        >

                          Now

                        </MDButton>

                      </Grid>

                      <Grid item>

                        <MDButton

                          variant={schedule ? "contained" : "outlined"}

                          color="error"

                          startIcon={<CalendarToday />}

                          onClick={() => setSchedule(true)}

                        >

                          Schedule

                        </MDButton>

                      </Grid>

                      <Grid item>

                        {schedule && (

                          <DatePicker

                            style={{

                              color: darkMode ? "white" : "black",

                              backgroundColor: darkMode

                                ? "rgb(52 71 103)"

                                : "rgb(245 245 245)",

                            }}

                            variant="filled"

                            showTime={{ format: "HH:mm" }}

                            defaultValue={dayjs(selectedDate).tz("Asia/Dubai")}

                            disabledDate={disabledDate}

                            disabledTime={disabledTime}

                            onChange={(date) => setSelectedDate(date)}

                          />



                        )}

                      </Grid>

                    </Grid>



                    <FormControlLabel

                      control={

                        <Switch

                          checked={preview}

                          onChange={() => setPreview(!preview)}

                        />

                      }

                      label="Preview"

                      sx={{ mt: 2 }}

                    />



                    <MDButton

                      variant="gradient"

                      color="success"

                      onClick={handleSubmit}

                      sx={{ mt: 2 }}

                    >

                      Submit

                    </MDButton>

                  </CardContent>

                </Card>

              </Grid>



              {preview && (

                <Grid item xs={12} md={4}>

                  <Card variant="outlined" sx={{}}>

                    <CardContent>

                      <Typography variant="h6">Preview</Typography>

                      <MDBox

                        sx={{

                          textAlign: "center",

                          mb: 2,

                        }}

                      >

                        <Typography variant="subtitle1">iOS</Typography>

                        <MDBox

                          sx={{

                            position: "relative",

                            width: 234,

                            height: 240,

                            backgroundImage: `url(/cms-main-img/iphone16_1.png)`,

                            backgroundSize: "cover",

                            backgroundPosition: "center",

                            mx: "auto",

                          }}

                        >

                          <MDBox

                            sx={{

                              position: "absolute",

                              bottom: "10%",

                              left: "4%",

                              width: "92%",

                              display: "flex",

                              backgroundColor: "rgba(255, 255, 255, 0.75)",

                              borderRadius: 2,

                              p: 1,

                            }}

                          >

                            <MDBox

                              component="img"

                              src="/mm.png"

                              alt="Logo"

                              sx={{

                                width: 24,

                                height: 24,

                                mr: 1,

                                mt: 0.5,

                              }}

                            />



                            <MDBox

                              sx={{

                                display: "flex",

                                flexDirection: "column",

                                textAlign: "left",

                              }}

                            >

                              <MDTypography

                                variant="h6"

                                fontWeight="400"

                                fontSize="0.8rem"

                                lineHeight="18px"

                                sx={{

                                  wordBreak: "break-word",      // breaks long words 

                                  overflowWrap: "anywhere",     // modern browsers 

                                  whiteSpace: "normal",         // allows wrapping 

                                  display: "-webkit-box",

                                  WebkitBoxOrient: "vertical",

                                  WebkitLineClamp: 2,           // optional: max 2 lines 

                                  overflow: "hidden",

                                }}

                                style={{ color: "#344767" }}

                              >

                                {title || "No title"}

                              </MDTypography>



                              <MDTypography

                                variant="body"

                                fontSize="0.7rem"

                                lineHeight="14px"

                                sx={{

                                  wordBreak: "break-word",

                                  overflowWrap: "anywhere",

                                  whiteSpace: "normal",

                                  display: "-webkit-box",

                                  WebkitBoxOrient: "vertical",

                                  WebkitLineClamp: 2,

                                  overflow: "hidden",

                                }}

                                style={{ color: "#344767" }}

                              >

                                {description || "No Description"}

                              </MDTypography>

                            </MDBox>

                          </MDBox>

                        </MDBox>

                      </MDBox>

                      <MDBox

                        sx={{

                          textAlign: "center",

                          mb: 2,

                        }}

                      >

                        <Typography variant="subtitle1">Android</Typography>

                        <MDBox

                          sx={{

                            position: "relative",

                            width: 234,

                            height: 240,

                            backgroundImage: `url(/cms-main-img/iphone16_2.png)`,



                            backgroundSize: "cover",

                            backgroundPosition: "center",



                            mx: "auto",

                          }}

                        >

                          <MDBox

                            sx={{

                              position: "absolute",

                              bottom: "10%",

                              left: "4%",

                              width: "92%",

                              display: "flex",

                              backgroundColor: "rgba(255, 255, 255, 0.75)",

                              borderRadius: 2,

                              p: 1,

                            }}

                          >

                            <MDBox

                              component="img"

                              src="/mm.png"

                              alt="Logo"

                              sx={{

                                width: 24,

                                height: 24,

                                mr: 1,

                                mt: 0.5,

                              }}

                            />

                            <MDBox

                              sx={{

                                display: "flex",

                                flexDirection: "column",

                                textAlign: "left",

                              }}

                            >

                              <MDTypography

                                variant="h6"

                                fontWeight="400"

                                fontSize="0.8rem"

                                lineHeight="18px"

                                sx={{

                                  wordBreak: "break-word",

                                  overflowWrap: "anywhere",

                                  whiteSpace: "normal",

                                  display: "-webkit-box",

                                  WebkitBoxOrient: "vertical",

                                  WebkitLineClamp: 2,

                                  overflow: "hidden",

                                }}

                                style={{ color: "#344767" }}

                              >

                                {title || "No title"}

                              </MDTypography>

                              <MDTypography

                                variant="body"

                                fontSize="0.7rem"

                                lineHeight="14px"

                                sx={{

                                  wordBreak: "break-word",

                                  overflowWrap: "anywhere",

                                  whiteSpace: "normal",

                                  display: "-webkit-box",

                                  WebkitBoxOrient: "vertical",

                                  WebkitLineClamp: 2,

                                  overflow: "hidden",

                                }}

                                style={{ color: "#344767" }}

                              >

                                {description || "No Description"}

                              </MDTypography>

                            </MDBox>

                          </MDBox>

                        </MDBox>

                      </MDBox>

                    </CardContent>

                  </Card>

                </Grid>

              )}

            </Grid>

            <MDBox mt={6}>

              <Card>

                <MDBox

                  mx={2}

                  mt={-3}

                  py={1}

                  px={2}

                  variant="gradient"

                  bgColor={sidenavColor}

                  borderRadius="lg"

                  coloredShadow="info"

                >

                  <Grid

                    container

                    direction="row"

                    justifyContent="space-between"

                    alignItems="center"

                  >

                    <MDTypography variant="h6" color="white">

                      Schedule Notification

                    </MDTypography>

                  </Grid>

                </MDBox>

                {isScheduleTableLoading ? (

                  <Loader />

                ) : (

                  <CustomMaterialTable

                    columns={column1}

                    data={rows}

                    darkMode={darkMode}

                    toggleDensity={false}

                    onColumnVisibilityChange={setScheduleColumnVisibility}

                    state={{

                      columnVisibility: scheduleColumnVisibility,

                    }}

                  />

                )}

              </Card>

            </MDBox>

            <MDBox mt={6}>

              <Card>

                <MDBox

                  mx={2}

                  mt={-3}

                  py={1}

                  px={2}

                  variant="gradient"

                  bgColor={sidenavColor}

                  borderRadius="lg"

                  coloredShadow="info"

                >

                  <Grid

                    container

                    direction="row"

                    justifyContent="space-between"

                    alignItems="center"

                  >

                    <MDTypography variant="h6" color="white">

                      History

                    </MDTypography>



                    {/* Reload History */}

                    <TableRefreshButton

                      onRefresh={handleReloadHistory}

                      loading={isHistoryTableLoading}

                      tooltip="Reload History"

                      customSize={36}

                    />

                  </Grid>

                </MDBox>



                {isHistoryTableLoading ? (

                  <Loader />

                ) : (

                  <CustomMaterialTablePage

                    columns={columns}

                    data={rows1}

                    darkMode={darkMode}

                    manualPagination={true}

                    manualFiltering={false}

                    rowCount={totalRows}

                    paginationChange={(newPage) => setPagination(newPage)}

                    soringChange={handleSortingChange}

                    page={page}

                    pagesize={pageSize}

                    paginataion={pagination}

                    sorting={sorting}

                    searchText={searchText}

                    searchChange={handleSearchChange}

                    onColumnFiltersChange={setColumnFilters}

                    onColumnVisibilityChange={setColumnVisibility}

                    state={{

                      pagination,

                      sorting,

                      columnFilters,

                      columnVisibility,

                    }}

                    globalFilterDebounceMs={2000}

                  />

                )}

              </Card>

            </MDBox>

          </MDBox>

        ) : mode === "email" ? (

          <Emailnoti />

        ) : null}

      </DashboardLayout>

      {darkMode && (

        <GlobalStyles

          styles={{

            ".ant-segmented-item-selected .ant-segmented-item-label": {

              backgroundColor: "#344767 !important",

              color: "#ffffff !important",

              fontWeight: "bold",

            },

            ".ant-segmented-item-selected:hover": {

              backgroundColor: "#2c3e50 !important",

            },

            ".ant-segmented-thumb": {

              backgroundColor: "#344767 !important",

              transition: "none !important",

            },

            ".ant-segmented": {

              backgroundColor: "#202940 !important",

            },

          }}

        />

      )}

    </>

  );

}



export default Notifications;



